import { render } from "./ReportError.vue?vue&type=template&id=0d22fe2c&scoped=true"
import script from "./ReportError.vue?vue&type=script&lang=js"
export * from "./ReportError.vue?vue&type=script&lang=js"

import "./ReportError.vue?vue&type=style&index=0&id=0d22fe2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d22fe2c"]])

export default __exports__